import { useState, useEffect } from "react"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@f2e/ui/components/base"

export interface AlertBoxProps {
  title: string
  description: string | React.ReactNode
  open: boolean
  cancelText?: string
  confirmText?: string
  onOpenChange?: (open: boolean) => void
  onCancel?: (event: React.MouseEvent<HTMLButtonElement>) => void
  onConfirm?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const AlertBox = ({
  title,
  description,
  open,
  cancelText = "Cancel",
  confirmText = "Continue",
  onOpenChange,
  onCancel,
  onConfirm,
}: AlertBoxProps) => {
  const [show, setShow] = useState<boolean>(open)

  useEffect(() => {
    setShow(open)
  }, [open])

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setShow(false)
    onCancel?.(e)
  }

  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setShow(false)
    onConfirm?.(e)
  }

  const handleOpenChange = (open: boolean) => {
    onOpenChange?.(open)
    setShow(open)
  }

  return (
    <AlertDialog open={show} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-gray-500">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleCancel}>
            {cancelText}
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm}>
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default AlertBox
